
import {BrowserModule, DomSanitizer, SafeHtml} from '@angular/platform-browser';
import { DateTimeFormatPipe } from './../../date-time-format.pipe';
import { DateFormatPipe } from './../../date-format.pipe';
import { SafeHtmlPipe} from './../../safe-html.pipe';
import { ClientesPymesService } from './../../services/clientes-pymes.service';
import { MensajesService } from './../../services/mensajes.service';
import { IntervinientesService } from './../../services/intervinientes.service';
import { UsuariosService } from './../../services/usuarios.service';
import { ClientesService } from './../../services/clientes.service';
import { AuthService } from './../../services/auth.service';
import { Component, OnInit, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import 'rxjs/Rx';
import { saveAs } from 'file-saver/FileSaver';
import { TimeFormatPipe } from '../../time-format.pipe';


@Component({
  selector: 'app-mensaje',
  templateUrl: './mensaje.component.html',
  styleUrls: ['./mensaje.component.css'],
  providers:[DateFormatPipe, TimeFormatPipe, SafeHtmlPipe]
})
export class MensajeComponent implements OnInit {

  @ViewChild("mensajeEnviado") mensajeEnviado: ElementRef;
  
  codigo;
  mensaje:{}={};
  emailEmisor="";
  archivo:string="";
  adjuntos= [];
  //para varios clientes
  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};
  textoMensaje:SafeHtml;

  nombreArchivo1;
  nombreArchivo2;
  nombreArchivo3;
  nombreArchivo4;
  nombreArchivo5;
  nombreArchivo6;
  nombreArchivo7;
  nombreArchivo8;
  nombreArchivo9;
  nombreArchivo10;

  nombresArchivos;
  archivos;
  
  
  @ViewChild("subirArchivo")  archivoSubido: ElementRef;
  @ViewChild("subirArchivo2") archivoSubido2: ElementRef;
  @ViewChild("subirArchivo3") archivoSubido3: ElementRef;
  @ViewChild("subirArchivo4") archivoSubido4: ElementRef;
  @ViewChild("subirArchivo5") archivoSubido5: ElementRef;
  @ViewChild("subirArchivo6") archivoSubido6: ElementRef;
  @ViewChild("subirArchivo7") archivoSubido7: ElementRef;
  @ViewChild("subirArchivo8") archivoSubido8: ElementRef;
  @ViewChild("subirArchivo9") archivoSubido9: ElementRef;
  @ViewChild("subirArchivo10") archivoSubido10: ElementRef;

  constructor(private auth:AuthService, private mensajesService:MensajesService,
     private activatedRoute:ActivatedRoute, private location:Location, private usuariosService:UsuariosService,
     private intervinientesService:IntervinientesService, private clientesService:ClientesService,
     private clientesPymesService:ClientesPymesService, private renderer:Renderer2, 
     private dateformat:DateFormatPipe, private datetime:TimeFormatPipe, private sanitizer:DomSanitizer) {

    
    this.activatedRoute.params.subscribe(params=>{
      this.codigo=params["cod"];
    });
  }

  ngOnInit() {
      if(this.codigo=="nuevo"){
        
        if(this.auth.esCliente()){
          this.intervinientesService.getNombresIntervinientesCliente(this.auth.usuarioActivo.CLcodigo).subscribe();
          this.usuariosService.getNombresUsuariosCliente(this.auth.usuarioActivo.CLcodigo).subscribe();
        }else if(this.auth.esClientePymes()){
          this.intervinientesService.getNombresIntervinientesClientePymes(this.auth.usuarioActivo.CLcodigo).subscribe();
          this.usuariosService.getNombresUsuariosClientePymes(this.auth.usuarioActivo.CLcodigo).subscribe();
        }else if(this.auth.esInterviniente()){
          this.usuariosService.getNombresUsuariosInterviniente(this.auth.usuarioActivo.INcodigo).subscribe();
        }else if(this.auth.esAdmin()){
          this.intervinientesService.getNombresIntervinientes().subscribe();
          this.usuariosService.getNombresUsuarios().subscribe();
          this.clientesService.getNombresClientes().subscribe();
        }else if(this.auth.esAdminPymes()){
          this.clientesPymesService.getListaClientes().subscribe();
          this.usuariosService.getNombresUsuarios().subscribe();
        }

        this.prepararNuevoMensaje();
        
        if(this.activatedRoute.snapshot.queryParams.tipo && this.activatedRoute.snapshot.queryParams.idusuario){
          this.mensaje["MEparatipo"]=this.activatedRoute.snapshot.queryParams.tipo;
          this.cambiarTipoReceptor(this.activatedRoute.snapshot.queryParams.idusuario);
        }
        
        this.selectedItems = [];
        
        this.dropdownSettings = {
          singleSelection: false,
          idField: 'CLcodigo',
          textField: 'CLnombre',
          selectAllText: 'Seleccionar todos',
          unSelectAllText: 'Deseleccionar todos',
          itemsShowLimit: 3,
          allowSearchFilter: true
        };

      }else{
        this.cargarMensaje();

      }
      
  }

  onItemSelect(event){
    
  }

  cargarMensaje(){
    this.mensajesService.getMensaje(this.codigo).subscribe(resp=>{
      this.mensaje=resp["mensaje"];
      this.textoMensaje=this.sanitizer.bypassSecurityTrustHtml(this.mensaje['MEdescripcion']);
      if(this.mensaje["USemail"]){
        this.emailEmisor=this.mensaje["USemail"];
      }else if(this.mensaje["CLemail"]){
        this.emailEmisor=this.mensaje["CLemail"];
      }else{
        this.emailEmisor=this.mensaje["INemail"];
      }
    });
    this.mensajesService.getAdjuntos(this.codigo).subscribe(resp=>{
      this.adjuntos=resp["adjuntos"];
      
    });
    
    

  }

  prepararNuevoMensaje(){
    this.mensaje={
          MEasunto:"",
          MEdescripcion:"",
          MEparacodigo:"",
          MEparanombre:"",
          MEleido:0,
          MEeliminadorecibido:0,
          MEeliminadoenviado:0
        };
    
    if(this.auth.esCliente()){
      this.mensaje["MEparatipo"]="U";
      this.mensaje["MEdetipo"]='C';
      this.mensaje["MEdecodigo"]=this.auth.usuarioActivo.CLcodigo;
      this.mensaje["MEdenombre"]=this.auth.usuarioActivo.CLnombre;
    
    }else if(this.auth.esAdmin()){
      this.mensaje["MEdetipo"]='U';
      this.mensaje["MEdecodigo"]=this.auth.usuarioActivo.UScodigo;
      this.mensaje["MEdenombre"]=this.auth.usuarioActivo.USnombre;

    }else if(this.auth.esInterviniente()){
      this.mensaje["MEdetipo"]='I';
      this.mensaje["MEparatipo"]='U';
      this.mensaje["MEdecodigo"]=this.auth.usuarioActivo.INcodigo;
      this.mensaje["MEdenombre"]=this.auth.usuarioActivo.INnombre;

    }else if(this.auth.esAdminPymes()){
      this.mensaje["MEdetipo"]='UP';
      this.mensaje["MEdecodigo"]=this.auth.usuarioActivo.UScodigo;
      this.mensaje["MEdenombre"]=this.auth.usuarioActivo.USnombre;

    }else if(this.auth.esClientePymes()){
      
      this.mensaje["MEdetipo"]='CP';
      this.mensaje["MEdecodigo"]=this.auth.usuarioActivo.CLcodigo;
      this.mensaje["MEdenombre"]=this.auth.usuarioActivo.CLnombre;

    }

    
  }

  imprimirMensaje(){
    
    let printContents;
    printContents = document.getElementById('divImprimir').innerHTML;

    var ventana = window.open('', 'PRINT', 'height=400,width=600');
    ventana.document.write('<html><head><title>' + document.title + '</title>');
    ventana.document.write('<style type="text/css" media="print">'
    +'@page '
    +'{'
        +'size: auto;'
        +'margin-top: 0mm;'
    +'}'
    +'</style>');
    ventana.document.write('</head><body>');
    ventana.document.write('<div id="divImprimir" style="margin-top: 50px;">'
    +'<img src="./assets/img/logo_solucion-legal.png" height="75px" style="margin:0 auto;" />'
    +'<div class="row">'
    +  '<span class="col-md-6 text-left my-1"><b>'+this.mensaje["MEasunto"]+'</b></span>'
    +  ''
    +'</div>'
    +'<div class="row pt-3" style="border-top: 1px solid rgb(138, 138, 138); padding-top:10px;">'
    +  '<span class="col-md-6 text-left" style="text-align:left;">'+this.mensaje["MEdenombre"]+'</span>'
    +  '<span class="col-md-6 text-right" style="float:right;">'+this.dateformat.transform(this.mensaje["MEfecha"])+'</span>'
    +'</div>'
    +'<div class="row pb-3" style="border-bottom:1px solid rgb(138,138,138); padding-bottom:10px">'
    +  '<small class="col-md-6 text-left" style="text-align:left;"><b>'+this.mensaje["emailemisor"]+'</b></small>'
    +  '<span class="col-md-6 text-right" style="float:right;">'+this.datetime.transform(this.mensaje["MEfecha"])+'</span>'
    +'</div>'

    +'<div class="col-md-10 mx-auto my-3 p-2" style="border-top: 1px solid rgb(138, 138, 138);padding:5px; padding-top:15px;">'+this.mensaje["MEdescripcion"]+'</div>');

    
    ventana.document.write('</body></html>');
    ventana.document.close();
    ventana.focus();
    ventana.onload = function() {
      ventana.print();
      ventana.close();
    };


  }

  irAtras(){
    this.location.back();
  }

  enviarMensaje(){

    if(this.validarDatos()){
    
      if(this.mensaje["MEparatipo"]=="varios"){
        this.mensajesService.enviarMensajeVariosClientes( this.selectedItems, this.mensaje, this.archivo, this.archivoSubido.nativeElement.files[0])
        .subscribe(resp=>{
          let texto=this.renderer.createText(resp["msg"]);
            if(resp["err"]==false){
              this.nombresArchivos=[
                this.nombreArchivo1,
                this.nombreArchivo2,
                this.nombreArchivo3,
                this.nombreArchivo4,
                this.nombreArchivo5,
                this.nombreArchivo6,
                this.nombreArchivo7,
                this.nombreArchivo8,
                this.nombreArchivo9,
                this.nombreArchivo10
              ];
          
              this.archivos=[
                this.archivoSubido,
                this.archivoSubido2,
                this.archivoSubido3,
                this.archivoSubido4,
                this.archivoSubido5,
                this.archivoSubido6,
                this.archivoSubido7,
                this.archivoSubido8,
                this.archivoSubido9,
                this.archivoSubido10
              ];
              for(let i=0;i<this.archivos.length;i++){

                if(this.archivos[i] && this.archivos[i].nativeElement.files.length>0){
                  let adjunto={ MAmasivo : true,
                                MAnombre: this.nombresArchivos[i]};
                  
                  this.insertarAdjuntoMasivo(adjunto, this.archivos[i].nativeElement.files[0], resp["ids_creados"]);              
                }
              }
              this.renderer.addClass(this.mensajeEnviado.nativeElement, "text-success");
            }else{
              this.renderer.addClass(this.mensajeEnviado.nativeElement, "text-danger");
            }

            this.renderer.appendChild(this.mensajeEnviado.nativeElement,texto);
            setTimeout(() => {
              this.renderer.removeChild(this.mensajeEnviado.nativeElement,texto);
              this.location.back();
            }, 2000);
        });
      
      }else if(this.mensaje["MEparatipo"]=="variosPymes") {
        this.mensajesService.enviarMensajeVariosClientesPymes( this.selectedItems, this.mensaje, this.archivo, this.archivoSubido.nativeElement.files[0])
        .subscribe(resp=>{
          let texto=this.renderer.createText(resp["msg"]);
            if(resp["err"]==false){
              this.nombresArchivos=[
                this.nombreArchivo1,
                this.nombreArchivo2,
                this.nombreArchivo3,
                this.nombreArchivo4,
                this.nombreArchivo5,
                this.nombreArchivo6,
                this.nombreArchivo7,
                this.nombreArchivo8,
                this.nombreArchivo9,
                this.nombreArchivo10
              ];
          
              this.archivos=[
                this.archivoSubido,
                this.archivoSubido2,
                this.archivoSubido3,
                this.archivoSubido4,
                this.archivoSubido5,
                this.archivoSubido6,
                this.archivoSubido7,
                this.archivoSubido8,
                this.archivoSubido9,
                this.archivoSubido10
              ];
              for(let i=0;i<this.archivos.length;i++){

                if(this.archivos[i] && this.archivos[i].nativeElement.files.length>0){
                  let adjunto={ MAmasivo : true,
                                MAnombre: this.nombresArchivos[i]};
                  
                  this.insertarAdjuntoMasivo(adjunto, this.archivos[i].nativeElement.files[0], resp["ids_creados"]);              
                }
              }
              this.renderer.addClass(this.mensajeEnviado.nativeElement, "text-success");
            }else{
              this.renderer.addClass(this.mensajeEnviado.nativeElement, "text-danger");
            }

            this.renderer.appendChild(this.mensajeEnviado.nativeElement,texto);
            setTimeout(() => {
              this.renderer.removeChild(this.mensajeEnviado.nativeElement,texto);
              this.location.back();
            }, 2000);
        });
      }else{

        switch(this.mensaje["MEparatipo"]){
          case "C":
            this.mensaje["MEparanombre"]=this.clientesService.listaClientes.find(x=>x.CLcodigo==this.mensaje['MEparacodigo']).CLnombre;
            
          break;
    
          case "U":
            this.mensaje["MEparanombre"]=this.usuariosService.listaUsuarios.find(x=>x.UScodigo==this.mensaje['MEparacodigo']).USnombre;
            
          break;
    
          case "I":
            this.mensaje["MEparanombre"]=this.intervinientesService.listaIntervinientes.find(x=>x.INcodigo==this.mensaje['MEparacodigo']).INnombre;
            
          break;
    
          case "UP":
            this.mensaje["MEparanombre"]=this.usuariosService.listaUsuarios.find(x=>x.UScodigo==this.mensaje['MEparacodigo']).USnombre;
            
          break;
    
          case "CP":
            this.mensaje["MEparanombre"]=this.clientesPymesService.listaClientes.find(x=>x.CLcodigo==this.mensaje['MEparacodigo']).CLnombre;
            
          break;
        }

        this.mensajesService.enviarMensaje(this.mensaje, this.archivo)
        .subscribe(resp=>{

          let texto=this.renderer.createText(resp["msg"]);
            if(resp["err"]==false){
              this.nombresArchivos=[
                this.nombreArchivo1,
                this.nombreArchivo2,
                this.nombreArchivo3,
                this.nombreArchivo4,
                this.nombreArchivo5,
                this.nombreArchivo6,
                this.nombreArchivo7,
                this.nombreArchivo8,
                this.nombreArchivo9,
                this.nombreArchivo10
              ];
          
              this.archivos=[
                this.archivoSubido,
                this.archivoSubido2,
                this.archivoSubido3,
                this.archivoSubido4,
                this.archivoSubido5,
                this.archivoSubido6,
                this.archivoSubido7,
                this.archivoSubido8,
                this.archivoSubido9,
                this.archivoSubido10
              ];

              for(let i=0;i<this.archivos.length;i++){

                if(this.archivos[i] && this.archivos[i].nativeElement.files.length>0){
                  let adjunto={ MAcodmensaje  : resp["id_introducido"],
                                MAnombre: this.nombresArchivos[i]};
                  
                  this.insertarAdjunto(adjunto, this.archivos[i].nativeElement.files[0]);              
                }
              }
              this.renderer.addClass(this.mensajeEnviado.nativeElement, "text-success");
            }else{
              this.renderer.addClass(this.mensajeEnviado.nativeElement, "text-danger");
            }

            this.renderer.appendChild(this.mensajeEnviado.nativeElement,texto);
            setTimeout(() => {
              this.renderer.removeChild(this.mensajeEnviado.nativeElement,texto);
              this.location.back();
            }, 2000);
          
        });
      }

    }
    
  }

  cambiarTipoReceptor(newValue){
    switch(this.mensaje["MEparatipo"]){
      case "C":
        this.mensaje["MEparanombre"]=this.clientesService.listaClientes.find(x=>x.CLcodigo==newValue).CLnombre;
        
      break;

      case "U":
        this.mensaje["MEparanombre"]=this.usuariosService.listaUsuarios.find(x=>x.UScodigo==newValue).USnombre;
        
      break;

      case "I":
        this.mensaje["MEparanombre"]=this.intervinientesService.listaIntervinientes.find(x=>x.INcodigo==newValue).INnombre;
        
      break;

      case "UP":
        this.mensaje["MEparanombre"]=this.usuariosService.listaUsuarios.find(x=>x.UScodigo==newValue).USnombre;
        
      break;

      case "CP":
        this.mensaje["MEparanombre"]=this.clientesPymesService.listaClientes.find(x=>x.CLcodigo==newValue).CLnombre;
        
      break;
    }
  }

  descargarAdjunto(i){
    
    this.mensajesService.descargarAdjunto(this.adjuntos[i])
    .subscribe(data=>saveAs(data, this.adjuntos[i].MAfichero)),
    error=> console.log("Error downloading"),
    ()=>console.log("Nice.");
    //data=>window.open(window.URL.createObjectURL(data))
  }

  insertarAdjunto(adjunto, archivo){
    
    this.mensajesService.insertAdjuntoMensaje(adjunto, archivo).subscribe();
  }

  insertarAdjuntoMasivo(adjunto, archivo, idsCreados){
    this.mensajesService.insertAdjuntoMensajeMasivo(adjunto, archivo, idsCreados).subscribe();
  }


  validarDatos() {
    /* if(!this.mensaje["MEparacodigo"] || this.mensaje["MEparacodigo"]==""){
      let texto=this.renderer.createText("Debes introducir un destinatario");
      this.renderer.appendChild(this.mensajeEnviado.nativeElement,texto);
      this.renderer.addClass(this.mensajeEnviado.nativeElement, "text-danger");
      setTimeout(() => {
        this.renderer.removeChild(this.mensajeEnviado.nativeElement,texto);
        this.renderer.removeClass(this.mensajeEnviado.nativeElement, "text-danger");
      }, 2000);
      return false;
    } */

    if(this.mensaje["MEasunto"].trim()=="" || !this.mensaje["MEasunto"]){
      let texto=this.renderer.createText("Debes introducir un asunto");
      this.renderer.appendChild(this.mensajeEnviado.nativeElement, texto);
      this.renderer.addClass(this.mensajeEnviado.nativeElement, "text-danger");
      setTimeout(() => {
        this.renderer.removeChild(this.mensajeEnviado.nativeElement, texto);
        this.renderer.removeClass(this.mensajeEnviado.nativeElement, "text-danger");
      }, 2000);
      return false;
    }

    if(this.mensaje["MEdescripcion"].trim()=="" || !this.mensaje["MEdescripcion"]){
      let texto=this.renderer.createText("Debes introducir algo en el mensaje");
      this.renderer.appendChild(this.mensajeEnviado.nativeElement, texto);
      this.renderer.addClass(this.mensajeEnviado.nativeElement, "text-danger");
      
      setTimeout(() => {
        this.renderer.removeChild(this.mensajeEnviado.nativeElement, texto);
        this.renderer.removeClass(this.mensajeEnviado.nativeElement, "text-danger");
      }, 2000);
      return false;
    }
    
    return true;

  }

}



// WEBPACK FOOTER //
// ./src/app/components/mensaje/mensaje.component.ts